<template>
  <div>
    <el-dialog :visible.sync="dialogClient" :before-close="doClose" width="90%" top="5%" class="abow_dialog"
      :modal-append-to-body="false">
      <template slot="title">
        <span class="el-dialog__title">{{ title }}</span>
        <span v-if="!IsShowSensitive" class="el-dialog__title" style="margin-left: 50px">{{
          this.$t("desc.compressorNumber") + "：" + cNumbertitle }}</span>
      </template>
      <template>
        <div class="DeviceDiv">
          <el-row :gutter="24">
            <el-col :lg="6" :md="7" :sm="8" :xs="24" class="left">
              <img :src="DeviceInfo.imgUrl" style="width: 85%; max-width: 300px; cursor: pointer;"
                v-if="DeviceInfo.imgUrl" @click="toDeviceDigitalTwin(DeviceInfo.dsn)" />
              <img :src="k1" style="width: 85%; max-width: 300px" v-if="!DeviceInfo.imgUrl && !IsShowSensitive" />

              <img v-if="DeviceInfo.brandName == 'GD'" src="~assets/img/logo2.png"
                style="width: 60px; margin-bottom: 20px" />
              <img v-else src="~assets/img/logo.png" style="width: 60px; margin-bottom: 20px" />
              <!-- 品牌logo logo.png为IR的logo，logo2.png为GD的logo -->

              <div class="NoDeviceImg" v-if="!DeviceInfo.imgUrl && IsShowSensitive">
                {{ $t("desc.noPicture") }}
              </div>
              <div class="info">
                <div>
                  <span>{{ $t("title.productLine") }}</span>{{ DeviceInfo.kType }}
                </div>
                <div>
                  <span>{{ $t("title.productCategories") }}</span>{{ DeviceInfo.kProduct }}
                </div>
                <div>
                  <span>{{ $t("title.smallClassProduct") }}</span>{{ DeviceInfo.kSmall }}
                </div>
                <div>
                  <span>{{ $t("title.machineType") }}</span>{{ DeviceInfo.kPower }}
                </div>
                <div v-if="IsShowSensitive">
                  <span>{{ $t("title.airCompressorService") }}</span>
                  {{ DeviceInfo.serviceType }}
                </div>
                <div v-if="IsShowSensitive">
                  <span>{{ $t("title.controlsCCN") }}</span>
                  {{ DeviceInfo.ccn }}
                </div>
                <div v-if="IsShowSensitive">
                  <span>{{ $t("title.ccnVersion") }}</span>
                  {{ DeviceInfo.ccnVersion }}
                </div>
                <div>
                  <span>{{ $t("title.controllerModel") }}</span>
                  {{ DeviceInfo.ccnModel }}
                </div>
              </div>
              <div class="info">
                <div>
                  <span v-if="IsShowSensitive">{{
                    $t("desc.customerName")
                  }}</span>
                  <span v-else>{{ $t("desc.projectName") }}</span>
                  {{ CustomerInfo.customerName }}
                </div>
                <div v-if="IsShowSensitive" :md="24" :sm="24">
                  <span>{{ $t("title.customerCode") }}</span>{{ CustomerInfo.customerCode }}
                </div>
                <div v-if="IsShowSensitive" :md="24" :sm="24">
                  <span>{{ $t("title.customerCenter") }}</span>{{ CustomerInfo.customerCenter }}
                </div>
                <div v-if="IsShowSensitive" :md="24" :sm="24">
                  <span>{{ $t("title.companyType") }}</span>{{ $t(companyTypeList[CustomerInfo.companyType]) }}
                </div>
                <div v-if="IsShowSensitive">
                  <span>{{ $t("title.AirCompressorTotalNumber") }}</span>{{ CustomerInfo.deviceTotalCount }}
                </div>
              </div>
            </el-col>
            <el-col :lg="18" :md="17" :sm="16" :xs="24" class="right">
              <!-- 以下是增加利用率模块后的样式，整段替换掉上面的代码即可 -->
              <el-row :gutter="24" v-if="isDingOrBian == 'aaa'">
                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.AirCompressorStatus") }}</h4>
                        <span :style="SpanSize" ref="SpanHeight" :title="spantitle">{{
                          detailOnfo.kstate
                            ? activeLang == "zh"
                              ? detailOnfo.kstate
                              : $t("desc." + detailOnfo.kstate.trim())
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div v-if="IsShowSensitive" class="block">
                        <h4>{{ $t("title.RunningTime") }} (Hours)</h4>
                        <span>{{
                          detailOnfo.kTime ? detailOnfo.kTime : $t("tips.NA")
                        }}</span>
                      </div>
                      <div v-else class="block">
                        <h4>{{ $t("title.RunningTime") }}</h4>
                        <span>{{
                          detailOnfo.kTime
                            ? detailOnfo.kTime + $t("desc.simpleHours")
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>
                          {{ $t("desc.recent12loadingRate") }}
                          <el-tooltip class="item" effect="dark" placement="top" v-if="
                            $t('formula.最近12个月单台设备月加载率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月加载率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip>
                        </h4>
                        <div class="infoLine" id="LoadingLine" style="height: 51px"></div>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div v-if="IsShowSensitive" class="block">
                        <h4>{{ $t("title.LoadedTime") }} (Hours)</h4>
                        <span>{{
                          detailOnfo.loadTime
                            ? detailOnfo.loadTime
                            : $t("tips.NA")
                        }}</span>
                      </div>
                      <div v-else class="block">
                        <h4>{{ $t("title.LoadedTime") }}</h4>
                        <span>{{
                          detailOnfo.loadTime
                            ? detailOnfo.loadTime + $t("desc.simpleHours")
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.SystemPressure") }}</h4>
                        <span>{{
                          detailOnfo.systemPre
                            ? detailOnfo.systemPre
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col v-if="DeviceInfo.ccnModel == 'MU'" :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.dischargePressurePac") }}</h4>
                        <span>{{
                          detailOnfo.dischargePre
                            ? detailOnfo.dischargePre
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col v-else :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.Stage1Pressure") }}</h4>
                        <span>{{
                          detailOnfo.stage1Pre
                            ? detailOnfo.stage1Pre
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.Stage1Virbation") }}</h4>
                        <span>{{
                          detailOnfo.stage1Vir
                            ? detailOnfo.stage1Vir
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col v-if="DeviceInfo.ccnModel == 'MU'" :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.Stage2InletTemp") }}</h4>
                        <span>{{
                          detailOnfo.stage2Intemp
                            ? detailOnfo.stage2Intemp
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col v-else :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.Stage1Temperature") }}</h4>
                        <span>{{
                          detailOnfo.stage1Temp
                            ? detailOnfo.stage1Temp
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6">
                  <el-row :gutter="24">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="block">
                        <h4>
                          {{ $t("desc.utilizationtrend") }}

                          <el-tooltip class="item" effect="dark" placement="top" v-if="
                            $t('formula.最近12个月单台设备月利用率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月利用率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip>
                        </h4>
                        <span style="text-align: left; height: 48px">{{
                          UseRateData.monthRate
                            ? UseRateData.monthRate + "%"
                            : UseRateData.monthRate == 0
                              ? "0%"
                              : $t("tips.NA")
                        }}</span>
                        <div class="infoLine" id="URateLine" style="height: 103px; margin-top: 23px"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row :gutter="24" v-else-if="isDingOrBian == 'aaa'">
                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.AirCompressorStatus") }}</h4>
                        <span :style="SpanSize" ref="SpanHeight" :title="spantitle">{{
                          detailOnfo.kstate
                            ? activeLang == "zh"
                              ? detailOnfo.kstate
                              : $t("desc." + detailOnfo.kstate.trim())
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div v-if="IsShowSensitive" class="block">
                        <h4>{{ $t("title.RunningTime") }} (Hours)</h4>
                        <span>{{
                          detailOnfo.kTime ? detailOnfo.kTime : $t("tips.NA")
                        }}</span>
                      </div>
                      <div v-else class="block">
                        <h4>{{ $t("title.RunningTime") }}</h4>
                        <span>{{
                          detailOnfo.kTime
                            ? detailOnfo.kTime + $t("desc.simpleHours")
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>
                          {{ $t("desc.recent12loadingRate") }}
                          <el-tooltip class="item" effect="dark" placement="top" v-if="
                            $t('formula.最近12个月单台设备月加载率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月加载率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip>
                        </h4>
                        <div class="infoLine" id="LoadingLine" style="height: 51px"></div>
                      </div>
                    </el-col>

                    <!-- <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.gatewaystatus") }}</h4> -->
                    <!-- <span
                        :style="
                          detailOnfo.beatStatus == 1
                            ? 'color:#62CF88'
                            : detailOnfo.beatStatus == 2
                            ? 'color:#EFCA3F'
                            : 'color:#F8454D'
                        "
                        >{{ $t(deviceStatuList[detailOnfo.beatStatus]) }}</span
                      > -->
                    <!-- <span>{{
                          $t(deviceStatuList[detailOnfo.beatStatus])
                        }}</span>
                      </div>
                    </el-col> -->
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div v-if="IsShowSensitive" class="block">
                        <h4>{{ $t("title.LoadedTime") }} (Hours)</h4>
                        <span>{{
                          detailOnfo.loadTime
                            ? detailOnfo.loadTime
                            : $t("tips.NA")
                        }}</span>
                      </div>
                      <div v-else class="block">
                        <h4>{{ $t("title.LoadedTime") }}</h4>
                        <span>{{
                          detailOnfo.loadTime
                            ? detailOnfo.loadTime + $t("desc.simpleHours")
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.DischargePressure") }}</h4>
                        <span>{{
                          detailOnfo.dp ? detailOnfo.dp : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.DischargeTemperature") }}</h4>
                        <span>{{
                          detailOnfo.sdt2 ? detailOnfo.sdt2 : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.RatedPressure") }}</h4>
                        <span>{{
                          detailOnfo.rp ? detailOnfo.rp : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.MotorCurrent") }}</h4>
                        <span>{{
                          detailOnfo.mc ? detailOnfo.mc : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6">
                  <div class="block">
                    <h4>
                      {{ $t("desc.utilizationtrend") }}
                      <el-tooltip class="item" effect="dark" placement="top" v-if="
                        $t('formula.最近12个月单台设备月利用率') &&
                        !IsShowSensitive
                      " :content="$t('formula.最近12个月单台设备月利用率')">
                        <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                      </el-tooltip>
                    </h4>
                    <span style="text-align: left; height: 48px">{{
                      UseRateData.monthRate
                        ? UseRateData.monthRate + "%"
                        : UseRateData.monthRate == 0
                          ? "0%"
                          : $t("tips.NA")
                    }}</span>
                    <div class="infoLine" id="URateLine" style="height: 103px; margin-top: 23px"></div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="24" v-else-if="isDingOrBian == 'aaa'">
                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.AirCompressorStatus") }}</h4>
                        <span :style="SpanSize" ref="SpanHeight" :title="spantitle">{{
                          detailOnfo.kstate
                            ? activeLang == "zh"
                              ? detailOnfo.kstate
                              : $t("desc." + detailOnfo.kstate.trim())
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div v-if="IsShowSensitive" class="block">
                        <h4>{{ $t("title.RunningTime") }} (Hours)</h4>
                        <span>{{
                          detailOnfo.kTime ? detailOnfo.kTime : $t("tips.NA")
                        }}</span>
                      </div>
                      <div v-else class="block">
                        <h4>{{ $t("title.RunningTime") }}</h4>
                        <span>{{
                          detailOnfo.kTime
                            ? detailOnfo.kTime + $t("desc.simpleHours")
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>
                          {{ $t("desc.recent12loadingRate") }}
                          <el-tooltip class="item" effect="dark" placement="top" v-if="
                            $t('formula.最近12个月单台设备月加载率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月加载率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip>
                        </h4>
                        <div class="infoLine" id="LoadingLine" style="height: 51px"></div>
                      </div>
                    </el-col>
                    <!-- <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.gatewaystatus") }}</h4> -->
                    <!-- <span
                        :style="
                          detailOnfo.beatStatus == 1
                            ? 'color:#62CF88'
                            : detailOnfo.beatStatus == 2
                            ? 'color:#EFCA3F'
                            : 'color:#F8454D'
                        "
                        >{{ $t(deviceStatuList[detailOnfo.beatStatus]) }}</span
                      > -->
                    <!-- <span>{{
                          $t(deviceStatuList[detailOnfo.beatStatus])
                        }}</span>
                      </div>
                    </el-col> -->
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.VsdMotorSpeed") }}</h4>
                        <span>{{
                          detailOnfo.vms ? detailOnfo.vms : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.DischargePressure") }}</h4>
                        <span>{{
                          detailOnfo.dp ? detailOnfo.dp : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.DischargeTemperature") }}</h4>
                        <span>{{
                          detailOnfo.sdt2 ? detailOnfo.sdt2 : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.TargetPressure") }}</h4>
                        <span>{{
                          detailOnfo.targetP
                            ? detailOnfo.targetP
                            : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ $t("title.DriverMotorCurrent") }}</h4>
                        <span>{{
                          detailOnfo.mc ? detailOnfo.mc : $t("tips.NA")
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6">
                  <el-row :gutter="24">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="block">
                        <h4>
                          {{ $t("desc.utilizationtrend") }}
                          <el-tooltip class="item" effect="dark" placement="top" v-if="
                            $t('formula.最近12个月单台设备月利用率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月利用率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip>
                        </h4>
                        <span style="text-align: left; height: 48px">{{
                          UseRateData.monthRate
                            ? UseRateData.monthRate + "%"
                            : UseRateData.monthRate == 0
                              ? "0%"
                              : $t("tips.NA")
                        }}</span>
                        <div class="infoLine" id="URateLine" style="height: 103px; margin-top: 23px"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ eightSpanTitleArr[isDingOrBian][0] }}</h4>
                        <span :style="SpanSize" ref="SpanHeight" :title="spantitle">{{
                          detailOnfo[eightSpanArr[isDingOrBian][0]]
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ eightSpanTitleArr[isDingOrBian][1] }}</h4>
                        <span>{{
                          detailOnfo[eightSpanArr[isDingOrBian][1]]
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>
                          {{ $t("desc.recent12loadingRate") }}
                          <el-tooltip class="item" effect="dark" placement="top" v-if="$t('formula.最近12个月单台设备月加载率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月加载率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip>
                        </h4>
                        <div class="infoLine" id="LoadingLine" style="height: 51px"></div>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ eightSpanTitleArr[isDingOrBian][2] }}</h4>
                        <span>{{
                          detailOnfo[eightSpanArr[isDingOrBian][2]]
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :xs="24" :sm="24" :md="9" :lg="9">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ eightSpanTitleArr[isDingOrBian][3] }}</h4>
                        <span>{{
                          detailOnfo[eightSpanArr[isDingOrBian][3]]
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ eightSpanTitleArr[isDingOrBian][4] }}</h4>
                        <span>{{
                          detailOnfo[eightSpanArr[isDingOrBian][4]]
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ eightSpanTitleArr[isDingOrBian][5] }}</h4>
                        <span>{{
                          detailOnfo[eightSpanArr[isDingOrBian][5]]
                        }}</span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12">
                      <div class="block">
                        <h4>{{ eightSpanTitleArr[isDingOrBian][6] }}</h4>
                        <span>{{
                          detailOnfo[eightSpanArr[isDingOrBian][6]]
                        }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6">
                  <el-row :gutter="24">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="block">
                        <h4>
                          {{ $t("desc.utilizationtrend") }}

                          <el-tooltip class="item" effect="dark" placement="top" v-if="$t('formula.最近12个月单台设备月利用率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月利用率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip>
                        </h4>
                        <div class="infoLine" id="URateLine" style="height: 51px;"></div>
                        <!-- <span style="text-align: left; height: 48px">{{
                          UseRateData.monthRate
                            ? UseRateData.monthRate + "%"
                            : UseRateData.monthRate == 0
                              ? "0%"
                              : $t("tips.NA")
                        }}</span>
                        <div class="infoLine" id="URateLine" style="height: 103px; margin-top: 23px"></div> -->
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                      <div class="block">
                        <h4>
                          {{ $t("desc.loadedChangeTrend") }}
                          <!-- <el-tooltip class="item" effect="dark" placement="top" v-if="$t('formula.最近12个月单台设备月利用率') &&
                            !IsShowSensitive
                          " :content="$t('formula.最近12个月单台设备月利用率')">
                            <el-button type="text" class="TitleBtn"><i class="fa fa-question-circle-o"></i></el-button>
                          </el-tooltip> -->
                        </h4>
                        <div class="infoLine" id="LoadedChangeLine" style="height: 51px;"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

              <!-- 以下开始展示右下角部分的代码 -->
              <div style="margin-top: 30px">
                <div class="echarts_Monitoring" style="border: 0; position: relative">
                  <el-tabs v-model="ActiveTab" type="border-card">
                    <el-tab-pane :label="!IsShowSensitive
                      ? $t('web.historymonitoring')
                      : $t('title.historymonitoring')
                      " name="history">
                      <template>
                        <div class="timeBtn">
                          <el-button-group class="timeBtn">
                            <el-button @click="refreshHistory" circle icon="el-icon-refresh" :title="$t('desc.refresh')"
                              style="background-color: #1f2128"></el-button>
                            <el-button v-if="hasExportHistory" @click="downLoadHistory" :loading="historyLoading" circle
                              icon="el-icon-download" :title="$t('button.export')"
                              style="background-color: #1f2128"></el-button>
                          </el-button-group>

                          <el-select multiple filterable collapse-tags :placeholder="$t('title.selectFive')"
                            v-model="KTarget.value2" :multiple-limit="5" @change="changeCode" style="
                              width: 50%;
                              min-width: 200px;
                              margin-left: 6px;
                              float: right;
                            ">
                            <el-option v-for="item in gatherOption" :key="item.id" :label="activeLang == 'zh' ? item.nameZH : item.name
                              " :value="item.name">
                            </el-option>
                          </el-select>
                          <el-date-picker v-model="KTarget.date" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                            align="right" unlink-panels :range-separator="$t('title.to')"
                            :start-placeholder="$t('title.beginDate')" :end-placeholder="$t('title.endDate')"
                            style="width: 250px; float: right" @blur="refreshHistory" :picker-options="pickerOptions"
                            :clearable="false">
                          </el-date-picker>
                          <!-- <el-date-picker
                          v-model="KTarget.date"
                          @blur="refreshHistory"
                          type="date"
                          :placeholder="$t('title.chooseDate')"
                          size="small"
                          style="float: right"
                          :clearable="false"
                          :picker-options="pickerBeginDateBefore"
                        >
                        </el-date-picker>-->
                        </div>

                        <div class="echarts" id="KchartTime2" style="height: 350px; margin-top: 15px"
                          v-show="ActiveTab == 'history'"></div>
                      </template>
                    </el-tab-pane>
                    <el-tab-pane :label="!IsShowSensitive
                      ? $t('web.realtimemonitoring')
                      : $t('title.realtimemonitoring')
                      " name="real">
                      <template>
                        <div class="timeBtn">
                          <el-button-group class="timeBtn">
                            <el-button icon="el-icon-refresh" circle :title="$t('desc.refresh')"
                              @click="changeActive(1)" style="background-color: #1f2128"
                              :class="activeClass == 1 ? 'active' : ''"></el-button>
                          </el-button-group>
                          <el-select multiple collapse-tags filterable :placeholder="$t('title.selectFive')"
                            v-model="KTarget.value2" :multiple-limit="5" @change="changeCode" style="
                              width: 50%;
                              min-width: 200px;
                              margin-left: 6px;
                              float: right;
                            ">
                            <el-option v-for="item in gatherOption" :key="item.id" :label="activeLang == 'zh' ? item.nameZH : item.name
                              " :value="item.name">
                            </el-option>
                          </el-select>
                        </div>

                        <div class="echarts" id="KchartTime" style="height: 350px; margin-top: 15px"></div>
                      </template>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('title.Alarm_View')" name="alarm">
                      <div class="tableDiv">
                        <div style="display: flex; position: relative; right: 0px; justify-content: end;">
                          <el-select v-model="tabAlarmDateType" filterable collapse-tags
                            :placeholder="$t('desc.select')" size="small" style="width: 30%">
                            <el-option value="3M" :label="$t('desc.recent3M')"></el-option>
                            <el-option value="6M" :label="$t('desc.t3To6M')"></el-option>
                            <el-option value="1Y" :label="$t('desc.t6To12M')"></el-option>
                            <el-option value="1YAgo" :label="$t('desc.t1YAgo')"></el-option>
                          </el-select>
                        </div>
                        <el-table :data="alarmList" stripe style="width: 100%" class="alarmTable" height="432px"
                          :key="tableKey">
                          <el-table-column type="index" :label="$t('title.serialNumber')" width="60" fixed="left">
                          </el-table-column>

                          <el-table-column prop="alarmType" :label="$t('title.alarmType')">
                            <template slot-scope="scope">
                              <label v-if="scope.row.alarmType == 'onWarning'">{{ $t("title.warning") }}</label>
                              <label v-else-if="scope.row.alarmType == 'onTrip'">{{ $t("title.trip") }}</label>
                            </template>
                          </el-table-column>

                          <el-table-column prop="alarmCode" :label="$t('title.alarmCode')" min-width="100px">
                          </el-table-column>
                          <el-table-column prop="ccn" :label="$t('title.controllCcn')" min-width="160px">
                          </el-table-column>
                          <el-table-column prop="ccnVersion" :label="$t('title.ccnVersion')" min-width="100px">
                          </el-table-column>
                          <el-table-column prop="alarmContent" :label="$t('title.alarmContent')" min-width="200px"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                              <label>{{
                                activeLang == 'zh' ? scope.row.alarmContent : scope.row.alarmContentEn
                              }}</label>
                            </template>
                          </el-table-column>
                          <!-- <el-table-column
                            prop="expertAdvice"
                            :label="$t('title.expertAdvice')"
                            min-width="200px"
                          >
                          </el-table-column> -->
                          <el-table-column prop="alarmTime" :label="$t('title.alarmTime')" min-width="170px">
                          </el-table-column>
                          <el-table-column prop="relieveTime" :label="$t('title.relieveTime')" min-width="170px">
                          </el-table-column>
                          <el-table-column :label="$t('title.operate')" width="110" fixed="right">
                            <template slot-scope="scope">
                              <el-button type="primary" icon="el-icon-document" :title="$t('desc.viewDetail')" circle
                                size="mini" @click="openWarningInfoDialog(true, scope.row)"></el-button>
                              <el-button type="default" icon="el-icon-download" :title="$t('button.export')" circle
                                size="mini" @click="exportTripWarningMonitor(scope.row)"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                        <el-pagination :page-size="pagination.pageSize" :page-sizes="[10, 20, 50]"
                          :current-page.sync="pagination.current" @current-change="handleCurrentChange"
                          @size-change="handleSizeChange" layout="prev, pager, next,sizes"
                          :total="pagination.totalPage">
                        </el-pagination>
                      </div>
                    </el-tab-pane>

                    <!-- 健康报告列表 -->
                    <el-tab-pane v-if="isAdmin" :label="$t('title.healthReport')" name="healthReport">
                      <div class="tableDiv">
                        <div style="display: flex; position: relative; right: 0px; justify-content: end;">
                        </div>
                        <el-table :data="healthReportList" stripe style="width: 100%" class="alarmTable" height="432px"
                                  :key="tableKey">
                          <el-table-column type="index" :label="$t('title.serialNumber')" width="60" fixed="left">
                          </el-table-column>

                          <el-table-column prop="cycleType" :label="$t('title.reportType')">
                            <template slot-scope="scope">
                              <label v-if="scope.row.cycleType == 'week'">{{ $t("title.week") }}</label>
                              <label v-else-if="scope.row.cycleType == 'month'">{{ $t("title.month") }}</label>
                            </template>
                          </el-table-column>

                          <el-table-column prop="cycle" :label="$t('title.healthReportTime')" min-width="100px">
                          </el-table-column>

                          <el-table-column prop="dsn" :label="$t('title.dsn')" min-width="100px">
                          </el-table-column>
                          <el-table-column prop="gsn" :label="$t('title.gsn')" min-width="160px">
                          </el-table-column>
                          <el-table-column prop="healthStatus" :label="$t('title.healthStatus')" min-width="100px">
                          </el-table-column>
                          <el-table-column prop="creationTime" :label="$t('title.creationTime')" min-width="170px">
                          </el-table-column>
                          <el-table-column :label="$t('title.operate')" width="110" fixed="right">
                            <template slot-scope="scope">
                              <el-button type="primary" icon="el-icon-document" :title="$t('desc.viewDetail')" circle
                                         size="mini" @click="openReportCustomizationDialog(true, scope.row)"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                        <el-pagination :page-size="pagination.pageSize" :page-sizes="[10, 20, 50]"
                                       :current-page.sync="pagination.current" @current-change="handleCurrentChange"
                                       @size-change="handleSizeChange" layout="prev, pager, next,sizes"
                                       :total="pagination.totalPage">
                        </el-pagination>
                      </div>
                    </el-tab-pane>

                    <el-tab-pane :label="$t('title.maintainTab')" name="maintain" v-if="IsShowSensitive">
                      <div class="tableDiv">
                        <el-table :data="maintainList" stripe style="width: 100%" class="alarmTable" height="432px">
                          <el-table-column type="index" :label="$t('title.serialNumber')" width="60">
                          </el-table-column>
                          <el-table-column prop="maintainRangeStr" :label="$t('title.maintainTypeDesc')"
                            min-width="200px">
                          </el-table-column>
                          <el-table-column prop="maintainTypeStr" :label="$t('title.serviceStatus')" min-width="150px">
                          </el-table-column>
                          <el-table-column :label="$t('title.operate')" width="120">
                            <template slot-scope="scope">
                              <el-button icon="el-icon-document" type="default" circle size="mini"
                                :title="$t('desc.serviceDetails')" v-if="scope.row.maintainType == 1"
                                @click="openMaintain(true, scope.row)"></el-button>
                              <el-button icon="el-icon-download" type="default" circle size="mini"
                                :title="$t('button.exportDetail')" style="font-weight: bold"
                                @click="exprtMaintain(scope.row)"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-tab-pane>

                    <el-tab-pane v-if="false" label="设备报表" name="reportList">
                      <div class="tableDiv">
                        <div class="timeBtn">
                          <el-date-picker v-model="ReportTime" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                            align="right" unlink-panels :range-separator="$t('title.to')"
                            :start-placeholder="$t('title.beginDate')" :end-placeholder="$t('title.endDate')"
                            style="width: 250px; float: right" :clearable="false">
                          </el-date-picker>
                          <el-select v-model="ReportType" style="
                              width: 150px;
                              float: right;
                              margin-right: 10px;
                            ">
                            <el-option label="PM报表" value="PM报表"></el-option>
                            <el-option label="误用报表" value="误用报表"></el-option>
                            <el-option label="告警摘要报表" value="告警摘要报表"></el-option>
                          </el-select>
                        </div>
                        <el-table :data="ReportData" stripe style="width: 100%" class="alarmTable" height="432px">
                          <el-table-column type="index" :label="$t('title.serialNumber')" width="60px">
                          </el-table-column>
                          <el-table-column prop="name" :label="$t('RunningTIme.Name')" min-width="120px">
                          </el-table-column>
                          <el-table-column prop="fileType" :label="$t('RunningTIme.Type')" min-width="50px">
                          </el-table-column>
                          <el-table-column prop="lastModified" :label="$t('RunningTIme.LastModify')" min-width="100px">
                          </el-table-column>
                          <el-table-column prop="size" :label="$t('RunningTIme.Size')" min-width="40px">
                          </el-table-column>
                          <el-table-column prop="storageClass" :label="$t('RunningTIme.StorageClass')" min-width="60px">
                          </el-table-column>
                          <el-table-column :label="$t('title.operate')" width="80px">
                            <template slot-scope="scope">
                              <el-button type="default" icon="el-icon-download" circle size="mini"
                                :title="$t('RunningTIme.Download')">
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                  <div class="tabButton">
                    <el-button class="fr" size="mini" style="
                        margin-top: 2px;
                        margin-right: 0px;
                        float: right;
                        font-size: 12px;
                        padding: 5px 14px;
                        background: rgba(0, 0, 0, 0);
                      " v-if="IsShowSensitive && hasCcnDetailAuth"
                      @click="openCcnTable(true, DeviceInfo.gsn, 'ccn')">{{ $t("title.tableDetail") }}
                    </el-button>
                    <el-button class="fr" size="mini" style="
                        margin-top: 2px;
                        font-size: 12px;
                        padding: 5px 14px;
                        background: rgba(0, 0, 0, 0);
                      " v-if="IsShowSensitive && hasMonitorDetailAuth"
                      @click="openCcnTable(true, DeviceInfo.gsn, 'monitor')">{{ $t("title.monitortableDetail") }}
                    </el-button>
                    <!-- <el-button class="fr" size="mini" :disabled="!isDisableDeviceInsightButton" style="
                        margin-top: 2px;
                        font-size: 12px;
                        padding: 5px 14px;
                        background: rgba(0, 0, 0, 0);
                      " v-if="IsShowSensitive && hasDeviceInsightAuth" @click="openDeviceInsight(DeviceInfo.gsn)">{{
                        $t("title.deviceInsight") }}
                    </el-button> -->
                  </div>
                  <!-- <div v-if="hasMonitorDetailAuth" class="tabButton"></div> -->
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
    <monitor-TripWarning-Dialog :tripdialogClient="dialogTripWarning" title="告警监控" :alarmId="alarmId"
      @dialogVisibleEvent="openTripWarningDialog">
    </monitor-TripWarning-Dialog>
    <warning-Info-Dialog :WarningInfoDialogClient="dialogWarningInfo" :title="$t('desc.alarmInfo')"
      :AlarmInfo="AlarmInfo" @dialogVisibleEvent="openWarningInfoDialog">
    </warning-Info-Dialog>
    <report-customization ref= "reportCustomization" @reviewReport="showHealth = true" @dialogVisibleEvent="closeReportCustomization" :dsn="healthReport.dsn" :gsn="healthReport.gsn" :health-report-id="healthReport.id" :cycle-type="healthReport.cycleType" :cycle="healthReport.cycle" :is-customer="isCustomer"/>

<!--    <div v-if="showHealth"><health-report @dialogVisibleEvent="showHealth = false"/></div>-->

  </div>



</template>

<script>
import Axios from "axios";
import {
  exportTripWarningMonitor,
  exportExcelNew,
  getMaintainExportData,
  exportExcel,
  getLatestMonitorDataProcess,
  authOperationCheck,
  getMonitorHistoryByGsn,
  getAlarmByGsn,
  getAlarmByDsnForWeb,
  getDeviceLoadedRateList,
  validDevice,
  dateFormat,
  getDigitalTwinData,
  pushToDigitalTwin,
  getHealthReportList, GetDeviceBasicInfo, GetDeviceRateList, GetCycleCoreData, GetLifecycleCoreData
} from "../../../api/api";
import k1 from "../../../assets/img/img_machine.png";
import monitorTripWarningDialog from "../../../components/content/monitor/MonitorTripWarning.vue";
import WarningInfoDialog from "../../../components/content/monitor/WarningInfoDialog.vue";
import healthReport from "../../../views/report/healthReport";
import healthReport2 from "../../../views/report/HealthReport2";
import ReportCustomization from "../../../views/report/ReportCustomization";
import {
  setItemToLocalstorage,
  getItemFormLocalstorage,
} from "../../../../utils/package-localstorage";
export default {
  name: "index",
  components: {
    "health-report": healthReport,
    "health-report2": healthReport2,
    "monitor-TripWarning-Dialog": monitorTripWarningDialog,
    "warning-Info-Dialog": WarningInfoDialog,
    "report-customization": ReportCustomization
  },
  props: {
    hasExportHistory: false,
    IsShowSensitive: true,
    activeLang: "",
    dialogClient: false,
    title: "",
    cNumbertitle: "",
    isDingOrBian: "",
    echartID: {},
    echartIDHistory: {},
    UseRateData: {},
    DeviceInfo: {
      dsn: "",
      gsn: "",
      kType: "",
      kProduct: "",
      kSmall: "",
      kPower: "",
      serviceType: "",
      kstate: "",
      kTime: "",
      loadTime: "",
      unLoadTime: "",
      beatStatus: "",
      dp: "",
      dt: "",
      rp: "",
      mc: "",
    },
    CustomerInfo: {
      customerCode: "",
      customerName: "",
      customerCenter: "",
      companyType: "",
      deviceTotalCount: "",
    },
    gatherOption: {
      type: Array,
      default: function () {
        return [];
      },
    },
    ccnCodeList222: {
      type: Array,
      default: function () {
        return [];
      },
    },
    maintainList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  watch: {
    dialogClient: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.authOperation("Device");
        }
      },
      deep: true,
    },
    ccnCodeList222: {
      handler(newValue, oldValue) {
        this.KTarget.value2 = new Array();
        this.KTarget.value2 = newValue;
        this.changeCode();
      },
      deep: true,
    },
    DeviceInfo: {
      handler(newValue, oldValue) {
        if (
          oldValue == null ||
          newValue.dsn == oldValue.dsn ||
          this.title.indexOf(newValue.dsn) >= 0
        ) {
          //防止数据错乱
          this.detailOnfo = newValue;
        }

        if (this.dialogClient && newValue.dsn !== oldValue.dsn) {
          this.setTitle();
          this.getDeviceLoadedRateList();
          //this.validDeviceInsight(newValue.dsn);
        }
      },
      deep: true,
      immediate: true,
    },
    ActiveTab: function (val) {
      //监听切换状态-计划单
      if (val == "history") {
        this.$nextTick(() => {
          if (this.echartIDHistory.id) {
            this.echartIDHistory.resize();
          }
        });
      } else if (val == "real") {
        this.changeTabTime++;
        if (this.changeTabTime == 1) {
          this.changeActive(1);
        }
        this.$nextTick(() => {
          if (this.echartID.id) {
            this.echartID.resize();
          }
        });
      } else if (val == "alarm") {
        if (this.dialogClient && this.isUpdateAlarm && this.IsShowSensitive) {
          this.getAlarmService("search");
          this.isUpdateAlarm = false;
        } else if (
          this.dialogClient &&
          this.isUpdateAlarm &&
          !this.IsShowSensitive
        ) {
          this.getAlarmByDsnForWeb("search");
          this.isUpdateAlarm = false;
        }
      } else if (val == "healthReport") {
        this.getHealthReportList("search");
      }
    },
    tabAlarmDateType: {
      handler(newValue, oldValue) {
        if (this.IsShowSensitive) {
          this.getAlarmService("search")
        } else {
          this.getAlarmByDsnForWeb("search");
        }
      },
      deep: true,
    },
    tabHealthReportDateType: {
      handler(newValue, oldValue) {
        this.getHealthReportList("search");
      },
      deep: true,
    }
  },
  data() {
    var that = this;
    return {
      showHealth: false,
      isCustomer: false,
      isAdmin: false,
      pickerOptions: {
        shortcuts: [{
          text: that.$t("desc.recent1D"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: that.$t("desc.recent3D"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: that.$t("desc.recent1W"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: that.$t("desc.recent1M"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          }
        }
          // , {
          //   text: that.$t("desc.recentThreeM"),
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
          //     picker.$emit('pick', [start, end]);
          //   }
          // }
        ]
      },
      encryptDsn: "",
      isDisableDeviceInsightButton: false,
      isValid: false,
      tableKey: 0,
      isUpdateAlarm: true,
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      alarmList: [],
      healthReportList: [],
      AlarmInfo: {},
      healthReport:{},
      dsn: "",
      dialoghealthReportOption: false,
      historyLoading: false,

      hasCcnDetailAuth: false,
      hasMonitorDetailAuth: false,
      hasDeviceInsightAuth: false,
      ReportType: "",
      ReportTime: "",
      ReportData: [
        {
          name: "Report2_PM_202958_20220305",
          fileType: "csv",
          lastModified: "2022-03-05 15:29:34",
          size: "3 MB",
          storageClass: "STANDARD",
        },
        {
          name: "Report3_Misuse_202958_20220226",
          fileType: "csv",
          lastModified: "2022-02-26 12:00:23",
          size: "2 MB",
          storageClass: "STANDARD",
        },
        {
          name: "Report2_PM_202958_20220219",
          fileType: "csv",
          lastModified: "2022-02-19 15:32:34",
          size: "3 MB",
          storageClass: "STANDARD",
        },
        {
          name: "Report6_Alarm_202958_20220212",
          fileType: "csv",
          lastModified: "2022-02-12 16:55:00",
          size: "4 MB",
          storageClass: "STANDARD",
        },
        {
          name: "Report6_Alarm_202958_202202005",
          fileType: "csv",
          lastModified: "2022-02-05 15:24:14",
          size: "3 MB",
          storageClass: "STANDARD",
        },
        {
          name: "Report6_Alarm_202958_20220129",
          fileType: "csv",
          lastModified: "2022-01-29 10:32:10",
          size: "3 MB",
          storageClass: "STANDARD",
        },
      ],
      dialogTripWarning: false,
      dialogWarningInfo: false,
      dialoghealthReport: false,
      companyTypeList: {
        直管: "desc.straightPipe",
        经销商: "desc.dealer",
        服务经销商: "desc.serviceDistributor",
        中间商: "desc.middleman",
        其他: "desc.other",
      },
      pickerMinDate: "",
      pickerBeginDateBefore: {
        onPick: (obj) => {
          that.pickerMinDate = new Date(obj.minDate).getTime();
          //console.log(obj);
        },
        disabledDate(time) {
          if (that.pickerMinDate) {
            const day1 = 2 * 24 * 3600 * 1000;
            let maxTime = that.pickerMinDate + day1;
            let minTime = that.pickerMinDate - day1;
            let day35 = Date.now() - 35 * 24 * 3600 * 1000;
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() > Date.now() ||
              time.getTime() < day35
            ); //大于所选时间加两天 小于所选时间减两天 大于今天的都禁止选择
          } else {
            let day35 = Date.now() - 35 * 24 * 3600 * 1000;
            return time.getTime() > Date.now() || time.getTime() < day35;
          }
        },
      },
      KTarget: {
        date: [new Date(), new Date()],
      },
      activeClass: 0,
      k1,
      detailOnfo: {},
      //翻译变量
      deviceStatuList: {
        0: "desc.DisconnectedNumber",
        1: "desc.normal",
        2: "tips.warning",
        "-1": "desc.offline",
      },
      pressTimes: 0,
      ActiveTab: "history",
      changeTabTime: 0,
      alarmId: "",
      WarnCurrentPage: 1,
      SpanSize: {
        fontSize: "24px",
        marginTop: "24px",
        opacity: 0,
      },
      spantitle: "",
      eightSpanArr: {
        'PacMU': ['kstate', 'kTime', 'loadTime', 'systemPre', 'dischargePre', 'stage1Vir', 'stage2Intemp'],
        'PacNotMU': ['kstate', 'kTime', 'loadTime', 'systemPre', 'stage1Pre', 'stage1Vir', 'stage1Temp'],
        'ding': ['kstate', 'kTime', 'loadTime', 'dp', 'sdt2', 'rp', 'mc'],
        'bian': ['kstate', 'kTime', 'vms', 'dp', 'sdt2', 'targetP', 'mc'],
        'BS5DH': ['BS5DH0', 'BS5DH1', 'BS5DH2', 'BS5DH3', 'BS5DH4', 'BS5DH5', 'BS5DH6'],
        'SVT': ['SVT0', 'SVT1', 'SVT2', 'SVT3', 'SVT4', 'SVT5', 'SVT6'],
        'BM200': ['BM2000', 'BM2001', 'BM2002', 'BM2003', 'BM2004', 'BM2005', 'BM2006'],
        'IDP': ['IDP0', 'IDP1', 'IDP2', 'IDP3', 'IDP4', 'IDP5', 'IDP6'],
        'MC': ['MC0', 'MC1', 'MC2', 'MC3', 'MC4', 'MC5', 'MC6'],
      },
      eightSpanTitleArr: {
        'PacMU': [
          this.$t("title.AirCompressorStatus"),
          this.$t("title.RunningTime"),
          this.$t("title.LoadedTime"),
          this.$t("title.SystemPressure"),
          this.$t("title.dischargePressurePac"),
          this.$t("title.Stage1Virbation"),
          this.$t("title.Stage2InletTemp")],
        'PacNotMU': [
          this.$t("title.AirCompressorStatus"),
          this.$t("title.RunningTime"),
          this.$t("title.LoadedTime"),
          this.$t("title.SystemPressure"),
          this.$t("title.Stage1Pressure"),
          this.$t("title.Stage1Virbation"),
          this.$t("title.Stage1Temperature")],
        'ding': [
          this.$t("title.AirCompressorStatus"),
          this.$t("title.RunningTime"),
          this.$t("title.LoadedTime"),
          this.$t("title.DischargePressure"),
          this.$t("title.DischargeTemperature"),
          this.$t("title.RatedPressure"),
          this.$t("title.MotorCurrent")],
        'bian': [
          this.$t("title.AirCompressorStatus"),
          this.$t("title.RunningTime"),
          this.$t("title.VsdMotorSpeed"),
          this.$t("title.DischargePressure"),
          this.$t("title.DischargeTemperature"),
          this.$t("title.TargetPressure"),
          this.$t("title.DriverMotorCurrent")],
        'BS5DH': [
          this.$t("eightSpan.BS5DH0"),
          this.$t("eightSpan.BS5DH1"),
          this.$t("eightSpan.BS5DH2"),
          this.$t("eightSpan.BS5DH3"),
          this.$t("eightSpan.BS5DH4"),
          this.$t("eightSpan.BS5DH5"),
          this.$t("eightSpan.BS5DH6")],
        'SVT': [
          this.$t("eightSpan.SVT0"),
          this.$t("eightSpan.SVT1"),
          this.$t("eightSpan.SVT2"),
          this.$t("eightSpan.SVT3"),
          this.$t("eightSpan.SVT4"),
          this.$t("eightSpan.SVT5"),
          this.$t("eightSpan.SVT6")],
        'BM200': [
          this.$t("eightSpan.BM2000"),
          this.$t("eightSpan.BM2001"),
          this.$t("eightSpan.BM2002"),
          this.$t("eightSpan.BM2003"),
          this.$t("eightSpan.BM2004"),
          this.$t("eightSpan.BM2005"),
          this.$t("eightSpan.BM2006")],
        'IDP': [
          this.$t("eightSpan.IDP0"),
          this.$t("eightSpan.IDP1"),
          this.$t("eightSpan.IDP2"),
          this.$t("eightSpan.IDP3"),
          this.$t("eightSpan.IDP4"),
          this.$t("eightSpan.IDP5"),
          this.$t("eightSpan.IDP6")],
        'MC': [
          this.$t("eightSpan.MC0"),
          this.$t("eightSpan.MC1"),
          this.$t("eightSpan.MC2"),
          this.$t("eightSpan.MC3"),
          this.$t("eightSpan.MC4"),
          this.$t("eightSpan.MC5"),
          this.$t("eightSpan.MC6")],
      },
      tabAlarmDateType: "3M",
      tabHealthReportDateType: "month",

      healthReportProp: {
        dsn: "",
        gsn: "",
        deviceBasicInfo:{},
        deviceUseRateList:[],
        cycleCoreData:{},
        deviceLoadedRateList:[],
        lifecycleCoreData:{}
      },
      healthReportDialog: false
    };
  },
  created() {
    let name = getItemFormLocalstorage('userName');
    let roles = getItemFormLocalstorage('roles')
    if (name === 'admin' || roles.some(r => r === 'Admin' || r === 'Admin Product')) {
      this.isAdmin = true;
    }
  },
  mounted() {

  },
  methods: {
    setSpan() {
      var tempheight = this.$refs.SpanHeight.offsetHeight;
      if (tempheight > 26) {
        this.SpanSize.fontSize = "18px";
        this.SpanSize.marginTop = "24px";

        let that = this;
        this.$nextTick(() => {
          var tempheight2 = that.$refs.SpanHeight.offsetHeight;
          if (tempheight2 > 26) {
            that.SpanSize.marginTop = "18px";
            that.spantitle = that.detailOnfo.kstate
              ? that.activeLang == "zh"
                ? that.detailOnfo.kstate
                : that.$t("desc." + that.detailOnfo.kstate.trim())
              : this.$t("tips.NA");
          }
        });
      } else {
        this.SpanSize.fontSize = "24px";
        this.SpanSize.marginTop = "24px";
      }
      this.SpanSize.opacity = 1;
    },
    setTitle() {
      let that = this;
      console.log('this.isDingOrBian', this.isDingOrBian);
      for (let index = 0; index < that.eightSpanTitleArr[this.isDingOrBian].length; index++) {
        const element = that.eightSpanTitleArr[this.isDingOrBian][index];
        if ((element == this.$t("title.RunningTime") || element == this.$t("title.LoadedTime") || element == this.$t("eightSpan.BS5DH1") || element == this.$t("eightSpan.BS5DH2")) && that.IsShowSensitive == true) {
          that.$set(that.eightSpanTitleArr[this.isDingOrBian], index, element + " (Hours)")
        } else {
          that.$set(that.eightSpanTitleArr[this.isDingOrBian], index, element)
        }
      }
    },
    async getDeviceLoadedRateList() {
      let that = this;
      let res = await getDeviceLoadedRateList(
        that.DeviceInfo.dsn,
        that.DeviceInfo.gsn
      );
      let data = res.result;
      this.$nextTick(() => {
        that.InitLoadingLine(data);
        that.setSpan();
      });
    },
    InitLoadingLine(data) {
      //设备监控详细页面 - 加载率折线图
      var that = this;
      var LoadingLine = this.$echarts.init(
        document.getElementById("LoadingLine")
      );
      var timeLine = data.dayTimeList;
      var dataLine = data.dayDataList;
      // var dataLine = [95,93,90,89,94,100,100,70,60,70,75,85,95,93,90];
      // var timeLine = [
      //   "2022-08-15","2022-08-14","2022-08-13","2022-08-12","2022-08-11","2022-08-10","2022-08-9","2022-08-8","2022-08-7","2022-08-6","2022-08-5","2022-08-4","2022-08-3","2022-08-2","2022-08-1",
      // ];
      // var timeLine = data.dayTimeList;
      var optionLoadingLine = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 + 20, point[1] - 80];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: "{b}<br />{a} : {c}% ",
        },
        grid: {
          top: 10,
          left: 0,
          right: 0,
          bottom: 3,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          boundaryGap: false,
          data: timeLine,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: {
          name: that.$t("desc.loadingRate"),
          type: "line",
          smooth: true, //是否平滑
          showAllSymbol: false,
          symbol: "circle",
          symbolSize: 5,
          lineStyle: {
            normal: {
              color: "rgba(255,255,255,1)",
            },
          },
          itemStyle: {
            color: "rgba(58,64,73,1)",
            borderColor: "rgba(255,255,255,1)",
            borderWidth: 1,
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(255,255,255,0.5)" },
                // { offset: 0.9, color: "rgba(255,255,255,0)" },
                { offset: 1, color: "rgba(255,255,255,0)" },
              ]),
            },
          },
          data: dataLine,
          cursor: "default",
        },
      };
      LoadingLine.setOption(optionLoadingLine);

      window.addEventListener("resize", () => {
        LoadingLine.resize();
      });
    },
    getAlarmService(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let postData = {
        dsn: that.DeviceInfo.dsn,
        dateType: that.tabAlarmDateType,
        skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
        maxResultCount: this.pagination.pageSize,
      };
      getAlarmByGsn(postData).then((res) => {
        this.tableKey = Math.random();
        that.pagination.totalPage = res.result.totalCount;
        that.alarmList = res.result.items;
        for (let index = 0; index < that.alarmList.length; index++) {
          if (that.alarmList[index].expertAdvice) {
            let expertList = new Array();
            let arr = that.alarmList[index].expertAdvice.split("|");
            for (let index = 0; index < arr.length; index++) {
              let element = arr[index];
              let detail = element.split(":");
              let problem = {
                reason: detail[0],
                solution: detail[1],
              };
              expertList.push(problem);
            }
            that.alarmList[index].expertList = expertList;
          }
        }
      });
    },

    getHealthReportList(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let postData = {
        dsn: that.DeviceInfo.dsn,
        dateType: that.tabHealthReportDateType,
        skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
        maxResultCount: this.pagination.pageSize,
      };
      getHealthReportList(postData).then((res) => {
        this.tableKey = Math.random();
        that.pagination.totalPage = res.result.totalCount;
        that.healthReportList = res.result.items;
      });
    },

    getAlarmByDsnForWeb(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let postData = {
        dsn: that.DeviceInfo.dsn,
        dateType: that.tabAlarmDateType,
        skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
        maxResultCount: this.pagination.pageSize,
      };
      getAlarmByDsnForWeb(postData).then((res) => {
        this.tableKey = Math.random();
        that.pagination.totalPage = res.result.totalCount;
        that.alarmList = res.result.items;
        for (let index = 0; index < that.alarmList.length; index++) {
          if (that.alarmList[index].expertAdvice) {
            let expertList = new Array();
            let arr = that.alarmList[index].expertAdvice.split("|");
            for (let index = 0; index < arr.length; index++) {
              let element = arr[index];
              let detail = element.split(":");
              let problem = {
                reason: detail[0],
                solution: detail[1],
              };
              expertList.push(problem);
            }
            that.alarmList[index].expertList = expertList;
          }
        }
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      if (this.IsShowSensitive) {
        this.getAlarmService();
      } else {
        this.getAlarmByDsnForWeb();
      }
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      if (this.IsShowSensitive) {
        this.getAlarmService();
      } else {
        this.getAlarmByDsnForWeb();
      }
    },
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCcnDetailAuth = res.hasCcnDetailAuth;
      that.hasMonitorDetailAuth = res.hasMonitorDetailAuth;
      that.hasDeviceInsightAuth = res.hasDeviceInsightAuth;
    },
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    // changCode(){
    //   var codeList=new Array();
    //   if (!this.KTarget.value2 || this.KTarget.value2.length==0 || this.KTarget.value2.indexOf("全部")!=-1) {
    //     for (let index = 0; index < this.gatherOption.length; index++) {
    //       codeList.push(this.gatherOption[index].name)
    //     }
    //   }else{
    //     codeList=this.KTarget.value2;
    //   }
    //   this.$emit("changCode", codeList);
    // },
    getRealData() {
      if (
        !this.KTarget.value2 ||
        !this.KTarget.value2 ||
        this.KTarget.value2.length == 0
      ) {
        this.$message({
          showClose: true,
          message: this.$t("tips.selectMonitoringParameters"),

          type: "error",
        });
        return false;
      }
      var codeList = new Array();
      if (
        !this.KTarget.value2 ||
        this.KTarget.value2.length == 0 ||
        this.KTarget.value2.indexOf("全部") != -1
      ) {
        for (let index = 0; index < this.gatherOption.length; index++) {
          codeList.push(this.gatherOption[index].name);
        }
      } else {
        codeList = this.KTarget.value2;
      }
      this.pressTimes++;
      this.$emit(
        "getRealData",
        this.activeClass,
        codeList,
        this.DeviceInfo.gsn,
        this.pressTimes
      );
    },
    changeActive(value) {
      this.activeClass = value;
      this.getRealData();
    },
    refreshHistory() {
      this.pickerMinDate = "";
      if (
        !this.KTarget.value2 ||
        !this.KTarget.value2 ||
        this.KTarget.value2.length == 0
      ) {
        this.$message({
          showClose: true,
          message: this.$t("tips.selectMonitoringParameters"),

          type: "error",
        });
        return false;
      }
      var codeList = new Array();
      if (
        !this.KTarget.value2 ||
        this.KTarget.value2.length == 0 ||
        this.KTarget.value2.indexOf("全部") != -1
      ) {
        for (let index = 0; index < this.gatherOption.length; index++) {
          codeList.push(this.gatherOption[index].name);
        }
      } else {
        codeList = this.KTarget.value2;
      }
      this.$emit(
        "getMonitorHistoryByGsn",
        codeList,
        this.DeviceInfo.gsn,
        this.KTarget.date
      );
    },
    async downLoadHistory() {
      this.historyLoading = true;
      // let curYear = this.KTarget.date[0].getFullYear();
      // let curMonth = this.KTarget.date[0].getMonth() + 1;
      // let curDay = this.KTarget.date[0].getDate();
      // let dateArr = [
      //   new Date(curYear, curMonth - 2, curDay),
      //   new Date(curYear, curMonth - 1, curDay),
      // ];

      let dateArr = this.KTarget.date;

      //console.log(dateArr);
      let postData = {
        gsn: this.DeviceInfo.gsn,
        date: dateArr,
        type: "Export"
      };
      try {
        let res = await getMonitorHistoryByGsn(postData);
        let data = res.result;

        let exportData = new Array();
        let titleList = [this.$t("title.Index")];
        titleList.push(...data.codeList);
        exportData.push(titleList);
        let fileName = this.$t("exportContent.监控历史数据") + "(" + dateFormat(dateArr[0], "yyyy-MM-dd", 0) + "~" + dateFormat(dateArr[1], "yyyy-MM-dd", 0) + ")" + " - " + this.DeviceInfo.dsn + ".xlsx";

        for (let index = 0; index < data.dateTimeList.length; index++) {
          const element = data.dateTimeList[index];
          let rowData = [element];
          data.chartDataList.forEach((item) => {
            rowData.push(item.dataList[index]);
          });
          exportData.push(rowData);
        }
        exportExcelNew(exportData, fileName);
        this.historyLoading = false;
      } catch (error) {
        this.historyLoading = false;
        this.$message({
          showClose: true,
          message: this.$t("desc.exportFailed"),
          type: "success",
        });
      }
    },
    changeCode() {
      var codeList = new Array();
      if (
        !this.KTarget.value2 ||
        this.KTarget.value2.length == 0 ||
        this.KTarget.value2.indexOf(this.$t("desc.all")) != -1
      ) {
        // for (let index = 0; index < this.gatherOption.length; index++) {
        //   codeList.push(this.gatherOption[index].name)
        // }
      } else {
        codeList = this.KTarget.value2;
        this.$emit(
          "getMonitorHistoryByGsn",
          codeList,
          this.DeviceInfo.gsn,
          this.KTarget.date
        );
      }
      this.$emit("changeCode", codeList);
    },
    openCcnTable(visible, gsn, type) {
      this.$emit("openCcnTable", visible, gsn, type);
    },
    async validDeviceInsight(dsn) {
      let that = this;
      const jse = new this.$jsEncrypt(); // 实例化一个 jsEncrypt 对象
      jse.setPublicKey(Globals.RSASYPublicKey); //配置公钥
      that.encryptDsn = jse.encrypt(dsn); //加密密码
      let res = await validDevice(that.encryptDsn);

      if (
        window.location.href.indexOf("test") > -1 ||
        window.location.href.indexOf("localhost") > -1
      ) {
        this.isDisableDeviceInsightButton = true;
        //以下为临时测试代码
        this.isValid = res.result;
        if (!this.isValid) {
          that.encryptDsn = jse.encrypt(Globals.SYTestDeviceSN); //加密密码
        }
      } else {
        that.isDisableDeviceInsightButton = res.result;
      }
    },
    openDeviceInsight() {
      let that = this;
      that.toDeviceInsight(that.encryptDsn);
    },
    toDeviceInsight() {
      let text = this.$router.resolve({
        name: "/device/deviceInsight",
        query: {
          dsn: this.encryptDsn
        },
      });
      window.open(text.href, "_blank");
    },
    async toDeviceDigitalTwin(dsn) {
      if (dsn == "MC-300") {
        //传递数据到DigtalTwin        
        let res = await getDigitalTwinData(dsn);
        let data = res.result;
        let deviceInfo_data = {
          "设备名称": "磁悬浮空压机",
          "设备型号": "MC300",
          "设备序列号": "BS20240911",
          "客户名称": "IR英格索兰",
          "应用行业": "空压机",
          "设备运行总时长": "2000小时"
        };
        let deviceStatus_data = {
          "机组状态": "启动",
          "1&2 罐速度": "400 RPM",
          "3&4 罐速度": "500 RPM",
          "排气压力": "11 Bar",
          "排气温度": "85℃",
          "气动功耗": "180 KM",
          "进水温度": "26℃",
          "进水压力": "3.2 Bar",
          "出水温度": "31℃",
          "出水压力": "2.8 Bar",
          "总功耗": "1400 KM",
          "总效率": "75%"
        };
        let nextMaintenancePlan_data = {};
        let unitRunningCurves_data = {};
        let motors_data = [];

        deviceInfo_data.设备名称 = data.deviceInfo.deviceName;
        deviceInfo_data.设备型号 = data.deviceInfo.deviceModel;
        deviceInfo_data.设备序列号 = data.deviceInfo.dsn;
        deviceInfo_data.客户名称 = data.deviceInfo.customerName;
        deviceInfo_data.应用行业 = data.deviceInfo.industryName;
        deviceInfo_data.设备运行总时长 = data.deviceInfo.runningTime;

        deviceStatus_data.机组状态 = data.deviceStatus.packageStatus;
        deviceStatus_data["1&2 罐速度"] = data.deviceStatus.mM1_Speed;
        deviceStatus_data["3&4 罐速度"] = data.deviceStatus.mM2_Speed;
        deviceStatus_data.排气压力 = data.deviceStatus.p_PackageDischarge;
        deviceStatus_data.排气温度 = data.deviceStatus.t_S4Discharge;
        deviceStatus_data.气动功耗 = data.deviceStatus.mM1_Power;
        deviceStatus_data.进水温度 = data.deviceStatus.t_PWater_Inlet;
        deviceStatus_data.进水压力 = data.deviceStatus.p_PWater_Inlet;
        deviceStatus_data.出水温度 = data.deviceStatus.t_PWater_Outlet;
        deviceStatus_data.出水压力 = data.deviceStatus.p_PWater_Outlet;
        deviceStatus_data.总功耗 = data.deviceStatus.totalPower;
        deviceStatus_data.总效率 = data.deviceStatus.overallEfficiency;

        data.unitRunningCurves.motors.forEach((o) => {
          motors_data.push({
            "转速/RPM": o.speed,
            "电流/A": o.current,
            "功率/KW": o.power,
            "电压/V": o.voltage,
            "振动XY/μm": o.vibration_XY,
            "振动UV/μm": o.vibration_UV,
            "振动Z/μm": o.vibration_Z
          });
        })

        let push_data = {
          "deviceInfo": {},
          "deviceStatus": {},
          "nextMaintenancePlan": {},
          "unitRunningCurves": {}
        };

        push_data.nextMaintenancePlan = data.nextMaintenancePlan;
        push_data.unitRunningCurves = data.unitRunningCurves;
        push_data.unitRunningCurves.motors = motors_data;

        push_data.deviceInfo = deviceInfo_data;
        push_data.deviceStatus = deviceStatus_data;

        console.log(JSON.stringify(push_data))
        let postdata = {
          dataStr: JSON.stringify(push_data),
        };

        window.open(Globals.DigitalTwinUrl, "_blank");

        //let pushRet = await pushToDigitalTwin(postdata);

        // var dtInstance=Axios.create({
        //   baseURL:"/request"
        // })
        // dtInstance.post("/data/sync", push_data).then(res => {
        //   window.open(Globals.DigitalTwinUrl, "_blank");
        // });

      }
    },
    openMaintain(visible, gsn) {
      this.$emit("openMaintain", visible, gsn);
    },
    //  openTripWarning(visible) {
    //   this.$emit("openTripWarning", visible);
    // },
    doClose() {
      this.isUpdateAlarm = true;

      this.pagination.totalPage = 0;
      this.alarmList = new Array();

      let data = {
        dayTimeList: new Array(),
        dayDataList: new Array(),
      };
      this.InitLoadingLine(data);

      this.$emit("dialogVisibleEvent", false);
      this.pressTimes = 0;
      this.KTarget = {
        value2: new Array(),
        date: [new Date(), new Date()],
      };
      this.ActiveTab = "history";
      this.changeTabTime = 0;
      this.tabHealthReportDateType = "month"
      //   this.$refs.gsnForm.resetFields();
    },
    async exportTripWarningMonitor(row) {
      try {
        let that = this;
        let res = await exportTripWarningMonitor(row.id);
        let data = res.result;

        let exportData = new Array();
        let titleList = [this.$t("title.Index")];
        titleList.push(...data.dateTimeList);
        exportData.push(titleList);
        let fileName =
          this.DeviceInfo.dsn +
          "_" +
          row.alarmTime
            .replace("-", "")
            .replace("-", "")
            .replace(":", "")
            .replace(":", "")
            .replace(" ", "") +
          "_" +
          row.alarmType.replace("on", "") +
          "_" +
          row.alarmCode +
          ".xlsx";
        data.detailList.forEach((element) => {
          let rowData = [element.name];
          element.dataList.forEach((item) => {
            rowData.push(item);
          });
          exportData.push(rowData);
        });
        exportExcelNew(exportData, fileName);
      } catch (error) {
        this.$message({
          showClose: true,
          message: error.error.message,

          type: "error",
        });
      }
    },
    openTripWarningDialog(visible) {
      //  this.alarmId = id;
      this.dialogTripWarning = visible;

      //  this.$emit("openTripWarningDialog", visible);
    },
    openWarningInfoDialog(visible, row) {
      this.AlarmInfo = row;
      this.dialogWarningInfo = visible;
    },
    openReportCustomizationDialog(visible, row) {
      this.healthReport = row;
      this.dsn = row.dsn;
      this.isCustomer = false;
      this.$refs.reportCustomization.showDialog();
    },
    closeReportCustomization() {
      this.healthReport = {};
      this.dsn = "";
    },
    exprtMaintain(row) {
      let that = this;
      var exportData = [
        [
          that.$t('desc.airCompressorSN'),
          that.$t('desc.ServiceOrderCode'),
          that.$t('desc.workExtent'),
          that.$t('desc.serviceItem'),
        ],
      ];

      var fileName = that.$t("exportContent.空压机服务明细") + " - " + row.dsn + ".xlsx";
      // var runningTimeInt = parseInt(row.maintainTime);
      // var mainTimeRange = runningTimeInt;
      // if (runningTimeInt > 1800 && runningTimeInt < 2500) mainTimeRange = 2000;
      // if (runningTimeInt > 3800 && runningTimeInt < 4500) mainTimeRange = 4000;
      // if (runningTimeInt > 7800 && runningTimeInt < 8500) mainTimeRange = 8000;
      // if (runningTimeInt > 15800 && runningTimeInt < 16500)
      //   mainTimeRange = 16000;
      if (!row.maintainTime) {
        row.maintainTime = Number.parseInt(row.maintainRange);
      }

      getMaintainExportData(row.dsn, row.maintainTime).then((res) => {
        if (res.result) {
          var data = res.result;
          if (res.result.length == 0) {
            this.$message({
              showClose: true,
              message: this.$t("desc.detailedDataNotFound"),
              type: "error",
            });
            return false;
          }
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach((item) => {
            let rowData = [
              item.dsn,
              item.serviceOrderCode,
              item.maintainItemName,
              item.subItemName,
            ];
            exportData.push(rowData);
          });
          exportExcelNew(exportData, fileName);
        }
      });
    }
  },
};
</script>

<style scoped>
.tabButton {
  position: absolute;
  right: 5px;
  top: 3px;
  color: #e6a23c;
  font-weight: 600;
  font-size: 14px;
}
</style>